import { rgbToHsb, rgbToHex } from '@shopify/polaris';
export { hsbToHex, rgbToHsb } from '@shopify/polaris';
import { nameHexMap } from './nameHexMap.mjs';

const RGB_STRING_TO_HEX_REGEX = /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i;
const IS_RGB_STRING_REGEX = /rgba?\(((25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,\s*?){2}(25[0-5]|2[0-4]\d|1\d{1,2}|\d\d?)\s*,?\s*([01]\.?\d*?)?\)/i;
const IS_HEX_STRING_REGEX = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
const IS_HASHLESS_HEX_STRING_REGEX = /(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i;
function hexToRgb(inputHex) {
  const hex = expandHex(inputHex);
  return {
    red: parseInt(hex.slice(1, 3), 16),
    green: parseInt(hex.slice(3, 5), 16),
    blue: parseInt(hex.slice(5, 7), 16)
  };
}
function hexToHsb(hex) {
  return rgbToHsb(hexToRgb(hex));
}
function expandHex(hex) {
  if (hex.length === 4) {
    return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  }
  return hex;
}
function nameToHex(value) {
  const hex = nameHexMap[normalizeValue(value)];
  return expandHex(`#${hex}`);
}
function rgbStringToHex(value) {
  const rgb = normalizeValue(value).match(RGB_STRING_TO_HEX_REGEX);
  return rgbToHex({
    red: parseInt(rgb[1], 10),
    green: parseInt(rgb[2], 10),
    blue: parseInt(rgb[3], 10)
  });
}
function isColorName(value) {
  return Boolean(nameHexMap[value]);
}
function isHexString(value) {
  return IS_HEX_STRING_REGEX.test(value);
}
function isHashlessHex(value) {
  return IS_HASHLESS_HEX_STRING_REGEX.test(value);
}
function isRgbString(value) {
  return IS_RGB_STRING_REGEX.test(value);
}
function normalizeValue(value) {
  return value.toLowerCase().replace(/\s/g, '');
}

export { expandHex, hexToHsb, hexToRgb, isColorName, isHashlessHex, isHexString, isRgbString, nameToHex, normalizeValue, rgbStringToHex };
